<div class="report-page-container">
    <div class="header-container">
      <!-- <div class="text-title-2">Similar On-Hand History</div> -->
       <div class="page-header-container">
        <a (click)="navigateBack()" class="text-title-2 back-ref" *ngIf="navigationState">
          {{(navigationState | navigatedFrom : 'Inventory' :  'inventory/ndc')?.name}}
        </a>
        <div class="text-title-2">  
          {{ 'Similar On-Hand History ' + (navigationState?.selectedNdc?.text ? 'for ' + navigationState.selectedNdc.text : '') }}
        </div>
       </div>
    
    </div>
  
    <div class="table-controls-container">
      <form [formGroup]="form"
            [ngClass]="{'active': isDrugsDropdownOpened}"
      >
      <div class="period-picker-container">
        <app-date-filter 
          [period]="form.get('period')" 
          [customPeriod]="form.get('customPeriod')"
          [isLoading]="isLoading$ | async"
          >
        </app-date-filter>
      </div>

        <app-multiselect-dropdown formControlName="drugs"
            id="drugs"
            [ngClass]="{'actual': isDrugsDropdownOpened}"
            [label]="'Drug'"
            [placeholder]="'All Drugs'"
            [data]="drugsList"
            [loading]="isLoading$ | async"
            [settings]="{allowSearchFilter: true}"
            [shouldFilterByNDC]="true"
            [itemsLimit]="3"
            [preSelectedItems]="[navigationState?.selectedNdc]"
            #drugsMultioptionalDropdown
        ></app-multiselect-dropdown>

        <app-inventory-locations-filter
          class="ml-2"
          label="Location"
          [control]="form.controls.inventoryLocations">
        </app-inventory-locations-filter>
      </form>
  
      <div class="header-controls">
        <app-button [text]="'Reset'"
                    styleClass="settings"
                    subStyle="blue"
                    customClasses="px-4 mr-2"
                    [minWidth]="0"
                    [disabled]="areFiltersEmpty() && !originalRecordsList?.length"
                    (clicked)="reset()"
        ></app-button>
        <app-button customClasses="px-4"
                    [text]="'Run Report'"
                    (clicked)="runReport()"
                    [loading]="runningReports$ | async"
        ></app-button>
      </div>
    </div>
  
    <div class="reports-table-container">
      <div *ngIf="(isLoading$ | async) !== true && !originalRecordsList?.length && !isReportRunApplied" class="empty-list-container">
        <div class="icon-wrapper">
          <img class="chart-icon" src="assets/icons/icon-chart-active.svg" alt="report-icon"/>
        </div>
        <div class="empty-list-header">Results</div>
        <div class="empty-list-description">
          Your report data will show up here.
        </div>
      </div>
  
      <app-empty-table *ngIf="(isLoading$ | async) !== true && !originalRecordsList?.length && isReportRunApplied"
                       [labelValue]="'There are no items to display.'"
                       [topOffset]="290"
      ></app-empty-table>
  
      <form [formGroup]="form" class="table-controls" *ngIf="originalRecordsList?.length">
        <div class="left-block">
          <app-search-input formControlName="searchValue"
                            [color]="SearchInputColorEnum.Blue"
                            [placeholder]="'Start typing...'"
                            [maxCharactersCount]="14"
                            [hideDropdown]="true"
          ></app-search-input>
        </div>
      </form>
  
      <table class="table-primary report-records-table" *ngIf="originalRecordsList?.length">
        <thead>
        <tr>
          <th (click)="sortByColumn('transactionDate')"
              class="text-left sort" scope="col"
          >
          DATE/TIME
            <img [class.asc]="tableColumns.transactionDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
          </th>
          <th class="text-left sort drug" scope="col">
            Drug
          </th>
          <th class="text-left sort activity" scope="col">
            Activity
          </th>
          <th class="text-left sort location" scope="col">
            Location
          </th>
          <th class="text-right sort starting" scope="col">
            SOH Starting
          </th>
          <th class="text-right sort count" scope="col">
            Count
          </th>
          <th class="text-right sort on-hand" scope="col">
            SOH Ending
          </th>
          <th class="text-left sort info" scope="col">
            Info
          </th>
        </tr>
        </thead>
        <tbody #tbody [appOverflowClass]>
  
        <app-search-empty-splash *ngIf="(isLoading$ | async) !== true && form.get('searchValue')?.value && sortedRecordsList?.length === 0"
                                 [searchValue]="form.get('searchValue')?.value"
        ></app-search-empty-splash>
  
        <ng-container *ngFor="let group of sortedRecordsList; let i = index">
          <tr class="group-header-container" (click)="groupItemsOpened[i] = !groupItemsOpened[i]">
            <td colspan="8">
              <img [class.close]="!groupItemsOpened[i]" class="icon-toggle"
                   src="assets/icons/icon-toggle-chevron-green.svg"
                   alt="toggle-icon"/>
              <div class="group-header">
                {{group.header}}
              </div>
            </td>
          </tr>
  
          <ng-container *ngIf="groupItemsOpened[i]">
            <tr class="table-row"
                (click)="openSidePanel(transaction?.transactionID)"
                *ngFor="let transaction of group.transactions; trackBy: trackByFn;"
            >
              <td class="text-left" scope="row">
                <div class="heading">
                  {{transaction?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
                </div>
                <div class="secondary">
                  {{transaction?.firstName}} {{transaction.lastName[0]}}.
                </div>
              </td>
              <td class="text-left drug">
                <div class="heading">
                  {{transaction?.friendlyName}}
                </div>
                <div class="secondary">
                  {{transaction?.packageNdc}}
                </div>
              </td>
              <td class="text-left activity">
                <app-badge [color]="(transaction | transactionBadge)?.color">
                  {{(transaction | transactionBadge)?.label}}
                </app-badge>
              </td>
              <td class="text-left location location-td">
                {{transaction?.locationName}}
              </td>
              <td class="text-right starting">
                {{transaction?.sohStartingQty | number}}
              </td>
              <td class="text-right count">
                {{transaction?.addedQuantity | number}}
              </td>
              <td class="text-right on-hand">
                {{transaction?.sohEndingQty | number}}
              </td>
              <td class="text-left info">
                <div class="heading" [auditOrderRedirectLinkClass] [activityType]="transaction?.activityType"
                  (click)="openAuditOrOrder(transaction?.transactionID)">
                  {{transaction?.infoHeading}}
                </div>
                <div class="secondary">
                  {{transaction?.infoSecondary}}
                </div>
                <div *ngIf="transaction?.infoSecondary2"
                  class="secondary"
                >
                  {{transaction.infoSecondary2}}
                </div>
              </td>
            </tr>
          </ng-container>
  
        </ng-container>
        </tbody>
      </table>
  
    </div>
    <app-button *ngIf="sortedRecordsList?.length && originalRecordsList?.length"
      customClasses="ml-3 px-4 mr-3 flex-start min-w-[117px]" [text]="'Download'" appMenu [loading]="isFileDownloading"
      [minWidth]="117" justifyTextPosition="left" [autoClose]="'outside'"
      [menuContent]="downloadMenuContent" triggers="manual" #downloadMenu="appMenu"
      (click)="downloadMenu.toggle();$event.stopPropagation();" [ngClass]="(loadingLibertyRxInventory$ | async) ? 'download-btn-left' : 'download-btn'">
      <img [class.opened]="downloadMenu.isOpen()" class="download-btn-icon" src="assets/icons/icon-chevron-down-white.svg"
        alt="chevron-down" />
    </app-button>
    <ng-template #downloadMenuContent>
      <div class="menu-container primary">
        <div (click)="savePDF();downloadMenu.close();$event.stopPropagation()" class="menu-item">
          <div class="option">Export as PDF</div>
        </div>
        <div (click)="saveCSV();downloadMenu.close();$event.stopPropagation()" class="menu-item">
          <div class="option">Save as CSV</div>
        </div>
      </div>
    </ng-template>
  </div>
  